import { Expose, Transform } from "class-transformer";
import { Allow, IsBoolean, IsIn, IsOptional, IsString } from "class-validator";
import { HEARD_ABOUT_US_OPTIONS } from "./heard-about-us";
import type { HeardAboutUsOption } from "./heard-about-us";

export class UpsertCustomerLeadInput {
  @Expose()
  @IsString()
  @IsOptional()
  email?: string;

  @Expose()
  @IsString()
  @IsOptional()
  firstName?: string;

  @Expose()
  @IsString()
  @IsOptional()
  lastName?: string;

  @Expose()
  @IsString()
  @IsOptional()
  leadSource?: string;

  /**
   * Self-reported attribution ("How did you hear about Yardzen?"). Only the
   * labels in `HEARD_ABOUT_US_OPTIONS` are accepted; anything else is rejected
   * so a stale client cannot write a value HubSpot has no option for.
   */
  @Expose()
  @Transform(({ value }) => (value === "" ? undefined : value))
  @IsOptional()
  @IsIn(HEARD_ABOUT_US_OPTIONS as unknown as string[])
  heardAboutUs?: HeardAboutUsOption;

  @Expose()
  @IsString()
  @IsOptional()
  surveyResponseId?: string;

  @Expose()
  @IsString()
  @IsOptional()
  phone?: string;

  @Expose()
  @IsString()
  @IsOptional()
  zipcode?: string;

  /** YardAI: whether the user uploaded a photo. Passed through to HubSpot note. */
  @Allow()
  @Expose()
  @IsBoolean()
  @IsOptional()
  uploadedPhoto?: boolean;

  /** YardAI: selected style name (e.g. "Modern/Contemporary"). Passed through to HubSpot note. */
  @Allow()
  @Expose()
  @IsString()
  @IsOptional()
  selectedStyle?: string;
}
